module.exports = __webpack_public_path__ + "static/ybs1-ada702eb02ccc57eaa2d7e0a0ce936b5.png";